import { AxiosInstance } from 'axios';
import { StoreCreditRevision } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'store-credit-revision';

export class StoreCreditRevisionApi {
  private apiInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getUserStoreCreditRevisions(userId: string): Promise<Array<StoreCreditRevision>> {
    await simulate();
    const response = await this.apiInstance.get(`/${userId}`);

    return response.data;
  }
}
